<template>
    <button
        class="player-button"
        v-bind="$attrs"
        :disabled="isDisabled"
        :class="{ playing: isPlaying }"
    >
        <svg v-if="type === 'play'" v-show="!isPlaying" class="icon-play" width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="27" cy="27" r="26.5" fill="white" stroke="white"/>
            <path d="M33.8182 25.6769C35.1515 26.4467 35.1515 28.3712 33.8182 29.141L24.4773 34.5339C23.1439 35.3037 21.4773 34.3415 21.4773 32.8019L21.4773 22.0159C21.4773 20.4763 23.1439 19.5141 24.4773 20.2839L33.8182 25.6769Z" fill="black"/>
        </svg>

        <svg v-if="type === 'play'" v-show="isPlaying" class="icon-pause" width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="27" cy="27" r="26.5" fill="white" stroke="white"/>
            <path d="M24 20L24 33" stroke="black" stroke-width="2" stroke-linecap="round"/>
            <path d="M30 20L30 33" stroke="black" stroke-width="2" stroke-linecap="round"/>
        </svg>

        <svg v-if="type === 'previouspreset'" width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="15" cy="15" r="15" fill="white"/>
            <path d="M10.5 15.866C9.83333 15.4811 9.83333 14.5189 10.5 14.134L18 9.80385C18.6667 9.41895 19.5 9.90007 19.5 10.6699L19.5 19.3301C19.5 20.0999 18.6667 20.5811 18 20.1962L10.5 15.866Z" fill="black"/>
            <path d="M10 10L10 20" stroke="black" stroke-width="2" stroke-linecap="round"/>
        </svg>

        <svg v-if="type === 'nextpreset'" width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="15" cy="15" r="15" fill="white"/>
            <path d="M19.5 14.134C20.1667 14.5189 20.1667 15.4811 19.5 15.866L12 20.1962C11.3333 20.5811 10.5 20.0999 10.5 19.3301L10.5 10.6699C10.5 9.90007 11.3333 9.41895 12 9.80385L19.5 14.134Z" fill="black"/>
            <path d="M20 20L20 10" stroke="black" stroke-width="2" stroke-linecap="round"/>
        </svg>
    </button>
</template>

<script>
export default {
    name: "PlayerButton",
    props: {
        type: {
            type: String,
            default: 'play'
        },
        isPlaying: {
            type: Boolean,
            default: false,
            required: false,
        },
        isDisabled: {
            type: Boolean,
            default: false,
            required: false,
        },
        size: {
            type: String,
            default: '50px',
            required: false,
        }
    }
}
</script>

<style lang="scss" scoped>
.player-button {
    width: v-bind(size);
    height: v-bind(size);
    padding: 0;
    outline: none;
    background: transparent;
}

svg {
    width: 100%;
    height: 100%;

    &:hover {
        circle {
            opacity: 0.7;
        }
    }
}

.player-button:disabled {
    svg {
        opacity: 0.4;
    }
    pointer-events: none;
}

</style>